import React from 'react';
const $ = window.$;

export default class Imagezoom extends React.Component {

    constructor(props) {
        super(props);
    }
   
    render() {
        let datasof=this.props;
        let izkey=(datasof.izkey)? datasof.izkey:new Date().getTime();
        
        return (
            <div>
                <a href={datasof.izsrc}  data-chittizoom>
                <img src={datasof.izsrc} key={izkey} height={datasof.izheight} width={datasof.izwidth} />
                </a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Imagezoom.js